if (!customElements.get('home-difference-v2')) {
  class HomeDifferenceV2 extends HTMLElement {
    /** @type {AbortController | null} */
    #abort = null;

    connectedCallback() {
      const hotspotElements = [...this.querySelectorAll('[data-hotspot]')];
      const panelElements = [...this.querySelectorAll('[data-panel]')];
      if (hotspotElements.length === 0 || hotspotElements.length !== panelElements.length) return;

      this.#abort = new AbortController();
      const { signal } = this.#abort;

      hotspotElements.forEach(
        /** @param {Element} hotspotElement @param {number} index */
        (hotspotElement, index) => {
          hotspotElement.addEventListener('click', () => this.#activate(hotspotElements, panelElements, index), { signal });
        },
      );
    }

    disconnectedCallback() {
      this.#abort?.abort();
      this.#abort = null;
    }

    /** @param {Element[]} hotspotElements @param {Element[]} panelElements @param {number} activeIndex */
    #activate(hotspotElements, panelElements, activeIndex) {
      hotspotElements.forEach(
        /** @param {Element} hotspotElement @param {number} index */
        (hotspotElement, index) => {
          hotspotElement.setAttribute('aria-pressed', index === activeIndex ? 'true' : 'false');
        },
      );
      panelElements.forEach(
        /** @param {Element} panelElement @param {number} index */
        (panelElement, index) => {
          if (panelElement instanceof HTMLElement) panelElement.hidden = index !== activeIndex;
        },
      );
    }
  }

  customElements.define('home-difference-v2', HomeDifferenceV2);
}
